
//Added this ".has-file-upload" class to the main logo product image options .hulkapps_option
document.addEventListener('DOMContentLoaded', function () {
  function processFileUploads() {
    const fileUploads = document.querySelectorAll('.file-upload');

    if (fileUploads.length) {
      fileUploads.forEach(function (fileUpload) {
        const optionWrapper = fileUpload.closest('.hulkapps_option');
        if (optionWrapper) {
          // ✅ Add class
          optionWrapper.classList.add('has-file-upload');
        }
      });
      // ✅ Stop observing once found & processed
      observer.disconnect();
    }
  }

  // ✅ Run once in case elements already exist
  processFileUploads();

  // ✅ Observe dynamically injected elements
  const observer = new MutationObserver(function () {
    processFileUploads();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

// Hide and show the logo images options, text properties, for the main logo product.
document.addEventListener("DOMContentLoaded", function () {

  console.log("✅ DOM Loaded");

  let isInitialized = false;

  function initConnectedOptions() {

    console.log("🔄 initConnectedOptions running");

    // ✅ MAIN PRODUCT SCOPE
    const mainScope = document.querySelector(".main_product_properties");
    if (!mainScope) {
      console.log("❌ mainScope not found");
      return;
    }

    // ✅ HULK OPTION CONTAINER
    const hulkScope = mainScope.querySelector(
      "[id^='hulkapps_options_'] [id^='hulkapps_option_list_'] .hulkapps_option_set"
    );
    if (!hulkScope) {
      console.log("❌ hulkScope not found");
      return;
    }

    // ✅ FILE UPLOADS
    const logoUploads = hulkScope.querySelectorAll(".has-file-upload");

    // ✅ EMBROIDERY SECTION
    const embroiderySection = document.querySelectorAll(
      ".main_product-properties_outer-container .main-prd_properties-embroidery"
    );

    // ✅ ✅ ✅ FIXED: TARGET REAL INPUTS (NOT SPANS)
    const embroideryTextInputs = document.querySelectorAll(
      ".main-prd_properties-embroidery label .text-emb input"
    );

    console.log("🧵 Embroidery INPUTS Found:", embroideryTextInputs.length);

    if (!logoUploads.length) {
      console.log("❌ No logo uploads found");
      return;
    }

    /* ==============================
       ✅ FIX: ISOLATE CLONED RADIOS
    ============================== */

    const clonedRadios = document.querySelectorAll(
      ".cloned_connected-product_options[name='logo_text_type']"
    );

    clonedRadios.forEach((radio) => {
      radio.name = "logo_text_type_cloned";
    });

    console.log("✅ Cloned radios isolated:", clonedRadios.length);

    /* ==============================
       ✅ VISIBILITY FUNCTIONS (POINTER EVENTS)
    ============================== */

    function hideLogoUploads() {
      console.log("🚫 Hiding logo uploads");
      logoUploads.forEach(el => {
        el.style.setProperty("pointer-events", "none", "important");
      });
    }

    function showLogoUploads() {
      console.log("✅ Showing logo uploads");
      logoUploads.forEach(el => {
        el.style.setProperty("pointer-events", "auto", "important");
      });
    }

    function showEmbroidery() {
      console.log("✅ Showing embroidery section");
      embroiderySection.forEach(el => {
        el.style.setProperty("pointer-events", "auto", "important");
      });
    }

    function hideEmbroidery() {
      console.log("🚫 Hiding embroidery section");
      embroiderySection.forEach(el => {
        el.style.setProperty("pointer-events", "none", "important");
      });
    }

    function showAllHulkOptions() {
      console.log("✅ Enabling all hulk options");
      hulkScope.querySelectorAll(".hulkapps_option").forEach(el => {
        el.style.setProperty("pointer-events", "auto", "important");
      });
    }

    /* ==============================
       ✅ EMBROIDERY INPUT CONTROL (FIXED)
    ============================== */

    function disableAndClearEmbroideryInputs() {
      console.log("🚫 Disabling & clearing embroidery inputs");

      embroideryTextInputs.forEach(input => {
        console.log("⛔ Disabled INPUT:", input);

        input.value = "";
        input.setAttribute("disabled", "disabled");
        input.blur();
      });
    }

    function enableEmbroideryInputs() {
      console.log("✅ Enabling embroidery inputs");

      embroideryTextInputs.forEach(input => {
        console.log("✅ Enabled INPUT:", input);

        // input.removeAttribute("disabled");
      });
    }

    /* ==============================
       ✅ NEW: UNCHECK ONLY EMBROIDERY RADIOS
    ============================== */

    function uncheckEmbroideryRadiosOnly() {
      console.log("🧹 Unchecking ONLY embroidery radios");

      const embroideryRadios = document.querySelectorAll(
        ".main-prd_properties-embroidery label input.radio"
      );

      embroideryRadios.forEach(radio => {
        radio.checked = false;
      });
    }

    /* ==============================
       ✅ RADIO CONTROL (ONLY ORIGINAL)
    ============================== */

    const radios = document.querySelectorAll(
      ".original-product_options[name='logo_text_type']"
    );

    console.log("🎛 Radios found:", radios.length);

    radios.forEach(radio => {

      if (radio.dataset.bound === "true") return;
      radio.dataset.bound = "true";

      radio.addEventListener("change", function () {

        const val = this.value.trim().toLowerCase();
        console.log("🎯 Radio changed to:", val);

        if (val === "logo") {
          console.log("✅ LOGO MODE ACTIVE");

          hideEmbroidery();
          showLogoUploads();
          showAllHulkOptions();
          disableAndClearEmbroideryInputs();

          // ✅ ONLY uncheck embroidery radios (NOT GLOBAL)
          uncheckEmbroideryRadiosOnly();
        }

        if (val === "logo_text") {
          console.log("✅ LOGO + TEXT MODE ACTIVE");

          showEmbroidery();
          showLogoUploads();
          showAllHulkOptions();
          enableEmbroideryInputs();
        }

        if (val === "text") {
          console.log("✅ TEXT MODE ACTIVE");

          showEmbroidery();
          hideLogoUploads();
          enableEmbroideryInputs();
        }

      });
    });

    /* ==============================
       ✅ FORCE FIRST ORIGINAL AS DEFAULT (ONLY ONCE)
    ============================== */

    if (!isInitialized && radios.length) {
      isInitialized = true;

      radios.forEach(r => (r.checked = false));
      radios[0].checked = true;

      console.log("⚡ Forcing default radio:", radios[0].value);

      radios[0].dispatchEvent(new Event("change", { bubbles: true }));
    }

    /* ==============================
       ✅ SAFETY RE-APPLY STATE AFTER MUTATION
    ============================== */

    const activeRadio = document.querySelector(
      ".original-product_options[name='logo_text_type']:checked"
    );

    if (activeRadio) {
      const val = activeRadio.value.trim().toLowerCase();
      console.log("🔁 Re-applying state for:", val);

      if (val === "logo") {
        disableAndClearEmbroideryInputs();
      } else {
        enableEmbroideryInputs();
      }
    }

  }

  /* ==============================
     ✅ MUTATION OBSERVER (REPLACES setTimeout)
  ============================== */

  const observer = new MutationObserver(function () {
    console.log("🧬 DOM mutation detected");
    initConnectedOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ✅ initial run
  initConnectedOptions();

});








